module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAJ1BMVEUAAAD/aZb/aY/6aZH7aY/9aY/9aZD7aY/8aY/8aY/9aY/8aY/8aY/TOqTxAAAADXRSTlMAESIzRGZ3iJm7zN3ulOPCIgAAAFJJREFUGNNjODlnJhjMYTBxYZjAyQAGnAzTshEcywOcCI7bBAwOO0j/dFQZITCHNQ0IUsHCEziZXYDAGcqB2TPIOKmaSBypFiQO2wQGRFAxOgAATZovAA7oTAYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/note-hover.png
// module id = 649
// module chunks = 0